import GtmFormularfeldId from "../../../../../gtm/types/GtmFormularfeldId";
import HundDto from "../../../../../consumer/form/dto/HundDto";
import StvJaNeinUnbekannt from "../../../../../consumer/form/dto/StvJaNeinUnbekannt";
import useInputSubmitValidator, { generateValidatorId } from "../../../../../form/input/useInputSubmitValidator";
import CheckboxField from "../../../../cmp/input/CheckboxField";
import useWizardFormCtx from "../../ctx-provider/useWizardFormCtx";
import FormBo from "../FormBo";
import HundeVersicherbarValidator from "./HundeVersicherbarValidator";

export const exportHundeVersicherbar = (bo: FormBo, hunde: HundDto[]) => {
    return versicherbarVisible(hunde) ? bo.hundeVersicherbarBest : undefined;
}

export const versicherbarVisible = (hunde: HundDto[]) => {
    //  Mind. eine Rassen ist NICHT versicherbar
    if (hunde.find(hund => hund.rasseVersicherbar !== undefined && hund.rasseVersicherbar === StvJaNeinUnbekannt.NEIN)) {
        return false;
    }

    //  Mind. eine Rasse ist unbekannt
    if (hunde.find(hund => hund.rasseVersicherbar !== undefined && hund.rasseVersicherbar === StvJaNeinUnbekannt.UNBEKANNT)) {
        return true;
    }

    // Solange ALLE Rassen unbekannt sind, wird das Feld ausgeblendet
    return false;
}

const VALIDATOR_ID = generateValidatorId("IhrTier-HundeVersicherbar");

const HundeVersicherbar: React.FC = () => {
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();

    // *** Validator wird initialisiert 
    const validator = new HundeVersicherbarValidator(wizardFormBo.ihrTier.hundeVersicherbarBest);
    const { validationState, fireFieldValidation } = useInputSubmitValidator(VALIDATOR_ID, validator);

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        wizardFormBo.ihrTier.hundeVersicherbarBest = event.target.checked;
        fireWizardFormBo(wizardFormBo);

        fireFieldValidation(new HundeVersicherbarValidator(wizardFormBo.ihrTier.hundeVersicherbarBest));
    }

    return (
        <CheckboxField id="rasseValid" idGtm={GtmFormularfeldId.rasseVersicherbar}
            error={validationState.error}
            helperText={validationState.message}
            preventSubmitOnEnter={false}
            value={wizardFormBo.ihrTier.hundeVersicherbarBest}
            label="Bitte bestätigen Sie uns, dass ihre Hunde nicht zu den durch die Rheinland nicht versicherbaren Hunderassen gehören."
            variant='caption'
            onChange={handleOnChange}></CheckboxField>

    );
}

export default HundeVersicherbar;
